import { motion } from 'framer-motion';
import { ArticleEntity } from 'graphql/blog/queries/article';

interface Props {
  article?: ArticleEntity;
}
const ArticleCard = ({ article }: Props) => {
  const { id, attributes } = article ?? {};
  const { title: articleTitle, excerpt, featured_media } = attributes ?? {};
  const { url: mediaUrl } = featured_media?.data?.attributes ?? {};

  return (
    <motion.div
      layoutId={`article-${id}`}
      whileHover={{
        scale: 1.025,
        transition: {
          duration: 0.25,
        },
      }}
      whileTap={{
        scale: 0.95,
      }}
      className='h-full cursor-pointer space-y-[20px]'
    >
      <motion.img
        layoutId={`article-image-${id}`}
        src={mediaUrl ?? '/images/error-404.svg'}
        alt={articleTitle}
        className='max-h-[250px] min-h-[250px] w-full rounded-[16px] bg-paper object-cover'
      />
      <motion.div layoutId={`article-content-${id}`} className='space-y-[20px]'>
        <motion.h1
          layoutId={`article-title-${id}`}
          className='cursor-pointer whitespace-pre-wrap text-[20px] font-[600] leading-[24px] text-service-text line-clamp-2'
        >
          {articleTitle ?? ''}
        </motion.h1>
        <span className='inline-block text-[16px] leading-[24px] text-service-text line-clamp-[7]'>
          {excerpt ?? ''}
        </span>
      </motion.div>
    </motion.div>
  );
};

export default ArticleCard;
